import { Link } from 'react-router-dom'
import './Finish.scss'
const Finish = () => {
  return (
    <>
      <section className="py-5 _finish">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <div className="wrapper">
                <h1 className="cong">Thank you for your submission!</h1>
                <span className="desc">Our team will contact you for further instructions.</span>
              </div>
              <Link to="/" className="back">BACK TO HOME</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Finish
